import { useMatch } from "@reach/router";

export function useMatchParams(path): TODO {
  return useMatch(path) || {};
}
